// Remote trainer PIN with daily rotation. Pure functions — no storage, no JSX.
//
// The 4-digit PIN is the ONLY key to the Firestore command channel
// (commands/{pin}/commands), so it must not live forever: the stored PIN is
// reused within the same local day (drawer reopens keep the phone pairing
// through a stevne evening), and the first open on a new day draws a fresh one.
// A stored PIN without a date (pre-rotation localStorage) also rotates.
export function generatePin() {
    return `${Math.floor(Math.random() * 9000) + 1000}`;
}

export function localDateKey(date = new Date()) {
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}

export function resolveRemotePin(saved, todayKey, generate = generatePin) {
    if (saved?.firebaseReceiverSessionId && saved.firebaseReceiverSessionIdDate === todayKey) {
        return { pin: saved.firebaseReceiverSessionId, isNew: false };
    }
    return { pin: generate(), isNew: true };
}
